<template>
  <div class="spinner" :class="['spinner__' + size, 'spinner__' + color ]" v-show="show" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { setTimeout, clearTimeout } from 'timers'

@Component
class Spinner extends Vue {
  @Prop({
    type: String,
    default: 'medium',
    validator: value => ['small', 'medium', 'large'].includes(value)
  }) size

  @Prop({
    type: String,
    default: 'white',
    validator: value => ['white', 'red'].includes(value)
  }) color

  @Prop({
    type: Number,
    default: () => 200
  }) delay

  show = false

  created () {
    this.timer = setTimeout(() => { this.show = true }, this.delay)
  }

  beforeDestroy () {
    clearTimeout(this.timer)
  }
}

export default Spinner
</script>

<style lang="scss">
$colorWhite: #fff;
$colorRed: #d20730;

.spinner {
  position: relative;

  &:before {
    box-sizing: border-box;
    content: "";
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    border: {
      radius: 50%;
      style: solid;
      width: 3px;
    }
    position: absolute;
    opacity: 1;
    transform: rotate(0deg) translate(-50%, -50%);
    transform-origin: 0 0;
    animation: loader 1.1s infinite linear;
  }
  &__white {
    &:before {
      border-color: transparent $colorWhite $colorWhite;
    }
  }
  &__red {
    &:before {
      border-color: transparent $colorRed $colorRed;
    }
  }
  &__small {
    width: 17px;
    height: 17px;
    @include media_tablet {
      width: 19px;
      height: 19px;
    }
  }
  &__medium {
    width: 26px;
    height: 26px;
    @include media_tablet {
      width: 36px;
      height: 36px;
    }
  }
  &__large {
    width: 50px;
    height: 50px;
  }
}

@keyframes loader {
  100% {
    transform: rotate(360deg) translate(-50%, -50%);
  }
}
</style>
